import { CheckCircle2, Info, XCircle, X } from 'lucide-react';
import { useUiStore } from '../../state/uiStore';
import { cn } from '../../lib/cn';

const icons = { info: Info, success: CheckCircle2, error: XCircle };

export function Toaster() {
  const toasts = useUiStore((s) => s.toasts);
  const dismissToast = useUiStore((s) => s.dismissToast);

  if (toasts.length === 0) return null;

  return (
    <div className="toaster">
      {toasts.map((toast) => {
        const Icon = icons[toast.kind];
        return (
          <div key={toast.id} className={cn('toast', `toast-${toast.kind}`)} role="status">
            <Icon size={18} />
            <span>{toast.message}</span>
            <button
              className="toast-dismiss"
              onClick={() => dismissToast(toast.id)}
              aria-label="Sluiten"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
